/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, {useEffect} from "react";
import {
  Box,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  ThemeProvider,
} from "@mui/material";
import CustomToolBar from "../../components/custom-toolbar";
import CustomFooter from "../../components/custom-footer";
import CustomDialog from "../../components/custom-dialog";
import { Stack } from "@mui/system";
import { useForm, Controller } from "react-hook-form";
import qs from 'qs'
import { useImmer } from "use-immer";
import useCompany from "../../hooks/use-company";
import theme from "../../theme";
import useApi from "../../hooks/use-api";
import { useNavigate , useParams, useLocation} from "react-router-dom";

const Forget = () => {
  // Data
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
  const { patchCRECareForgetPd } = useApi();
  const navigate = useNavigate();
  const {search} = useLocation();

  const [state, produce] = useImmer({
    verifyType: "0",
    dialogMsg: null,
    isApiSuccess: false,
    paths: [
      { title: "首頁", link: "/login" },
      { title: "會員登入", link: "/login" },
    ],
  });
  const { verifyType, dialogMsg, isApiSuccess, paths } = state;
  const { eDepartmentId } = useParams();
  const { setEDepartmentId, companyInfo } = useCompany();

  // #region CSS
  const card = css({
    width: "min(320px, 100vw - 40px)",
    padding: "50px 102px",
    borderRadius: "20px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    margin: "auto",
    "@media(max-width: 576px)": {
      padding: "10px 15px",
    },
  });
  const titleHint = css({ color: "#2b2b2b" });
  const textInput = css({ width: "100%", backgroundColor: "#f5f5f5" });
  const sendBtn = css({ padding: "10px 44px", backgroundColor: "#009043" });
  const radioBtn = css({
    color: "#009043",
    "&.Mui-checked": {
      color: "#009043",
    },
  });
  const helphint = css({ color: "gray", marginTop: "5px", fontSize: "12px"});
  // #endregion

  // #region Method
  const onTypeChange = (value) => {
    produce((draft) => void (draft.verifyType = value));
  };

  const handleDialogClose = () => {
    produce((draft) => void (draft.dialogMsg = null));
    isApiSuccess && navigate("/login");
  };

  const onSubmit = (datas) => {
    const params = {
      userId: datas.userId,
      isPhone: datas.verifyType === "0" ? true : false,
    };
    datas.verifyType === "0"
      ? (params["phone"] = datas.phone)
      : (params["email"] = datas.phone);

    patchForgetPasswordApi(params);
  };

  const patchForgetPasswordApi = async (params) => {
    await patchCRECareForgetPd({
      params,
      onSuccess: (result) => {
        if (result.isSuccess) {
          produce((draft) => {
            draft.dialogMsg = result.message;
            draft.isApiSuccess = true;
          });
        } else {
          produce((draft) => void (draft.dialogMsg = result.message));
        }
      },
      onFail: (result) => {
        console.log("[Test] patchCRECareChangePd onFail :", result);
      },
    });
  };

  const testPhoneOrMail = (val) => {
    if (verifyType === "0") {
      const phoneRegex = /^09\d{8}$/;
      return val.match(phoneRegex) ? true : "手機格式不符";
    } else {
      const mailRegex =
        /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      return val.match(mailRegex) ? true : "信箱格式不符";
    }
  };
  // #endregion
 
  useEffect(() => {
    if( !!search ){
      const accTest = qs.parse(search,{ignoreQueryPrefix:true})
      !!accTest  && setValue("userId", accTest?.acc )
    } 
  },[])

  useEffect(() => {
    !!eDepartmentId && setEDepartmentId(eDepartmentId);
  }, [eDepartmentId]);

  useEffect(() => {
    !!companyInfo &&
      produce(
        (draft) =>
          void (draft.paths = [
            { title: "首頁", link: `/${eDepartmentId}/login` },
            { title: companyInfo.name + "會員專區" , link: `/${eDepartmentId}/login` },
            { title: "會員登入", link: `/${eDepartmentId}/login` },
          ])
      );
  }, [companyInfo]);

  return (
    <ThemeProvider theme={theme}>
      <CustomToolBar title={"忘記密碼"} paths={paths} />
      <Box css={card}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2} alignItems="center">
            <h4 css={titleHint}>
              請輸入您的帳號，系統將發送簡訊至您註冊的手機號碼
            </h4>
            <TextField
              {...register("userId", { required: true })}
              label="帳號："
              variant="outlined"
              css={textInput}
              size="small"
              error={errors.userId ? true : false}
              helperText={errors.userId ? "必填" : ""}
            />
            <Controller
              name="verifyType"
              defaultValue="0"
              control={control}
              render={({ field }) => (
                <RadioGroup
                  row
                  {...field}
                  sx={{ alignSelf: "flex-start" }}
                  onChange={({ target }) => {
                    onTypeChange(target.value);
                    field.onChange(target.value);
                  }}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio css={radioBtn} />}
                    label="手機驗證"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio css={radioBtn} />}
                    label="信箱驗證"
                  />
                </RadioGroup>
              )}
            />
            <TextField
              {...register("phone", {
                required: true,
                validate: (val) => testPhoneOrMail(val),
              })}
              label={verifyType === "0" ? "手機號碼：" : "電子信箱："}
              variant="outlined"
              css={textInput}
              size="small"
              error={errors.phone ? true : false}
              helperText={errors.phone ? errors.phone.message : ""}
            />
            {/* <TextField
              {...register("code")}
              label="驗證碼："
              variant="outlined"
              placeholder="請依照大小寫輸入"
              css={textInput}
            /> */}
            <Stack alignItems="center">
              <Button variant="contained" css={sendBtn} type="submit">
                確認送出
              </Button>
              <label css={helphint}>如無法操作，請聯繫您的專員處理</label>
            </Stack>
          </Stack>
        </form>
      </Box>
      <CustomDialog
        isOpen={dialogMsg != null}
        title="合資公司"
        message={dialogMsg}
        isShowClose={false}
        onConfirm={handleDialogClose}
      />
      <CustomFooter />
    </ThemeProvider>
  );
};
export default Forget;
